// extracted by mini-css-extract-plugin
export default {"tx":"ee0072b3d5","line":"_0ee3d10c63"};